import { Borders, Row, Workbook, Worksheet } from "exceljs"
import moment from "moment"
import { MapJournalList } from "../../types"

type ExportExcelJournal = {
  data: MapJournalList[]
  companyName?: string
  module?: string
}

export const exportExcelJournal = async ({
  data,
  companyName,
  module
}: ExportExcelJournal) => {
  const workbook = new Workbook()
  const worksheet = workbook.addWorksheet("Sheet 1")
  const columns = [
    "DATE",
    "ID",
    "ACCOUNT",
    "NAME",
    "MEMO",
    "DEBIT",
    "CREDIT", 
    "JOB ID"
  ]
  worksheet.views = [{ showGridLines: false }]

  // Title
  makeTitle(worksheet, companyName, module)

  // Header
  const headers = worksheet.addRow(columns)
  headers.font = { bold: true, color: { argb: 'FFFFFFFF' } }
  headers.eachCell((cell) => {
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF000000" }
    }
    cell.border = {
      top: { style: "thin", color: { argb: "000000" } },
      left: { style: "thin", color: { argb: "000000" } },
      bottom: { style: "thin", color: { argb: "000000" } },
      right: { style: "thin", color: { argb: "000000" } }
    }
  })

  makeRows(data, worksheet)

  // create xlsx
  await workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    })
    const url = URL.createObjectURL(blob)
    const a = document.createElement("a")
    a.href = url
    a.download = `journal.xlsx`
    a.click()
    URL.revokeObjectURL(url)
  })
}

export const makeTitle = (worksheet: Worksheet, companyName?: string, module?: string) => {
  worksheet.mergeCells(1, 1, 1, 8)
  const cardCell = worksheet.getCell(1, 1)
  cardCell.value = module
  cardCell.alignment = {
    vertical: "middle",
    horizontal: "center",
    wrapText: true
  }
  cardCell.font = { bold: true, size: 15 }

  worksheet.mergeCells(2, 1, 2, 8)
  const titleCell = worksheet.getCell(2, 1)
  titleCell.value = "JOURNAL"
  titleCell.alignment = {
    vertical: "middle",
    horizontal: "center",
    wrapText: true
  }
  titleCell.font = { bold: true, size: 15 }

  for (let i = 1; i <= 8; i++) {
    worksheet.getColumn(i).width = 20
  }

  const companyNameCell = worksheet.addRow([companyName?.toUpperCase()])
  const currentRowIdx = worksheet.rowCount

  worksheet.mergeCells(currentRowIdx, 1, currentRowIdx, 8)

  companyNameCell.eachCell((cell) => {
    cell.alignment = {
      vertical: "middle",
      horizontal: "center",
      wrapText: true
    }
    cell.font = { bold: true, size: 15 }
  })
}

export const makeRows = (
  data: ExportExcelJournal["data"],
  worksheet: Worksheet
) => {
  let itemRow: Row

  const cellBorder: Partial<Borders> = {
    top: { style: "thin", color: { argb: "000000" } },
    left: { style: "thin", color: { argb: "000000" } },
    bottom: { style: "thin", color: { argb: "000000" } },
    right: { style: "thin", color: { argb: "000000" } }
  }

  data.forEach((date, _pIndex) => {
    date.data.data.forEach((item, cIndex) => {
      const isHeader = cIndex === 0
      const isFooter = cIndex === date.data.data.length - 1

      if (isHeader) {
        itemRow = worksheet.addRow([
          moment(date.date).format("DD/MM/YYYY"),
          date.data.source_memo,
          "",
          "",
          "",
          "",
          "",
          ""
        ])

        itemRow.font = { bold: true }
      } else if (isFooter) {
        itemRow = worksheet.addRow([
          "",
          "",
          "",
          "",
          item.memo,
          item.checkerDebit,
          item.checkerCredit,
          ""
        ])

        itemRow.font = { bold: true }
      } else {
        itemRow = worksheet.addRow([
          "",
          `${item.source_code} ${item.trx_code}`,
          item.coa_code,
          item.coa_name,
          item.memo
        ])
        itemRow.getCell(6).value = item.position === 1 ? item.amount : ""
        itemRow.getCell(7).value = item.position === 2 ? item.amount : ""
        itemRow.getCell(8).value = item.job_id
      }

      const cell = itemRow.getCell(7)

      cell.style = {
        font: {
          color: { argb: "00F87171" },
          bold: isFooter ? true : false
        }
      }
      itemRow.eachCell((cell) => {
        cell.border = cellBorder
      })
    })
  })
}
